import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import {
  baseCurrencyCode,
  prefixCcySymbol,
  suffixCcySymbol,
  thousandSeparatorByCurrency,
  decimalSeparatorByCurrency,
  decimalScaleByCurrency,
} from "../../utils/Currency";
import { useApp } from "../../contexts";
import { dateFormatNumber } from "../../utils/helper";

function ItemSubCard(props) {
  const {
    T,
    convertToLocalCurrency,
    getCurrency,
  } = useApp();
  const { itemData, onCancleSub, isHome } = props;
  const [price, setPrice] = useState(0);

  useEffect(() => {
    if (itemData) {
      setPrice(
        convertToLocalCurrency(itemData?.price, itemData?.currency_code, getCurrency())
      );
    }
  }, [itemData]);


  return (
    <>
      <div
        className={`w-auto item-boxs border-2 border-solid border-[#F3850F1A] rounded-[15px] cursor-pointer`}
      >
        <div className="flex justify-between items-center pt-[6px] pb-[16px] px-[12px] ">
          {itemData?.is_prime ? <>
            <div className="w-[83px] h-[83px] grow-0 shrink-0 rounded-[15px] overflow-hidden p-3 bg-[#F5F5F5]">
              <img
                  src={itemData.product_image}
                  alt=""
                  className="w-full h-full rounded-[15px]"
                />
            </div>
          </>: <div className="w-[83px] h-[83px] rounded-[15px] overflow-hidden">
            <img
              src={itemData.product_image}
              alt=""
              className="w-full h-full rounded-[15px]"
            />
          </div>}
          
          <div className="flex flex-col space-y-[10px]">
            <div className="mt-[8px] flex items-center justify-end">
              <span className={`text-[16px] text-[#000000]`}>&nbsp;</span>
              <div className="flex flex-wrap justify-end">
                <span className={`text-[#000000] text-[16px] font-bold`}>
                  <NumberFormat
                    className=""
                    value={price}
                    displayType={"text"}
                    thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                    decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                    prefix={prefixCcySymbol(true, getCurrency())}
                    suffix={suffixCcySymbol(true, getCurrency())}
                    decimalScale={decimalScaleByCurrency(
                      baseCurrencyCode(true, getCurrency())
                    )}
                  />
                  &nbsp;
                </span>
                <span className={`text-[#000000]`}>/{T("month")}</span>
              </div>
            </div>
            <div className="flex justify-end items-center space-x-[12px]">
              <div className="relative">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 8.27686C16 12.6951 12.4183 16.2769 8 16.2769C3.58172 16.2769 0 12.6951 0 8.27686C0 3.85858 3.58172 0.276855 8 0.276855C12.4183 0.276855 16 3.85858 16 8.27686ZM1.6 8.27686C1.6 11.8115 4.46538 14.6769 8 14.6769C11.5346 14.6769 14.4 11.8115 14.4 8.27686C14.4 4.74223 11.5346 1.87686 8 1.87686C4.46538 1.87686 1.6 4.74223 1.6 8.27686Z"
                    fill="#EAEAEA"
                  />
                  <path
                    d="M8 0.276855C9.83792 0.276855 11.6198 0.909698 13.046 2.06897L12.0368 3.31055C10.8958 2.38313 9.47034 1.87686 8 1.87686V0.276855Z"
                    fill="#E94444"
                  />
                </svg>
                <div className="day-left absolute text-[8px] top-[2px] left-[2px] w-[12px] text-center font-bold">
                  {itemData?.diffDay}
                </div>
              </div>
              <div className="text-[8px] font-[400]">{T("days left")}</div>
            </div>
            <div className="text-[8px] font-[400] text-right">
              {T("Next payment: {date}").replace(
                "{date}",
                dateFormatNumber(itemData?.end_date, "YYYY/MM/DD")
              )}
            </div>
          </div>
        </div>
        {!isHome ? (
          <div className="item-bottom flex items-center justify-between px-[14px] py-[4px] bg-[#F3850F1A] rounded-b-[14px]">
            <div className="truncate w-[calc(100%-100px)] text-[12px] font-semibold">
              {itemData?.product_name}
            </div>
            {itemData?.status == 1 && itemData?.user_canceled == 0 && (
              <div
                className="cursor-pointer italic text-[10px] text-[#E5665B]"
                onClick={() => onCancleSub(itemData)}
              >
                {T("Cancel Subscription")}
              </div>
            )}
          </div>
        ) : (
          <>
            <div className="item-bottom flex items-center justify-center px-[14px] py-[4px] bg-[#F3850F1A] rounded-b-[14px]">
              <div className="truncate text-[12px] font-semibold">
                {itemData?.product_name}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default ItemSubCard;
